import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Navbar.css";
import "./mediaCss.css";
import "./banner-anim.css";
import banner_1 from "../../Images/Banner/banner-1.webp";
// import banner_2 from "../../Images/Banner/banner-10.webp";
import banner_3 from "../../Images/Banner/banner-3.webp";
import banner_4 from "../../Images/Banner/banner-2.webp";
import banner_5 from "../../Images/Banner/banner-5.webp";
import banner_6 from "../../Images/Banner/banner-6.webp";
import banner_7 from "../../Images/Banner/banner-7.webp";
// import banner_8 from "../../Images/Banner/banner-8.webp";
import banner_9 from "../../Images/Banner/banner-12.png";
import banner_10 from "../../Images/Banner/banner-13.png";
import banner_11 from "../../Images/Banner/banner-14.png";

import Menubar from "../common/Menubar";
import MenubarMob from "../common/MenubarMob";

const Banner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const divRef = useRef(null);
  const targetRef = useRef(null);
  const [width, setWidth] = useState(null);
  const [hoveredSchool, setHoveredSchool] = useState(null);
  const [courses, setCourses] = useState([]);
  const [schools, setSchools] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Consolidated size adjustment function
  const adjustSize = () => {
    if (divRef.current && targetRef.current) {
      const containerWidth = divRef.current.offsetWidth;
      targetRef.current.style.width = `${containerWidth}px`;
      setWidth(containerWidth);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const response = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/schoolsApi",
        );
        setSchools(response.data.data);
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    };

    fetchSchools();
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        if (hoveredSchool) {
          const response = await axios.get(
            `https://isbmuniversity.edu.in/admin-portal/coursesList${hoveredSchool}`,
          );
          setCourses(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, [hoveredSchool]);

  const sliderRef = useRef(null);
  const ANIM_MS = 650; // keep in sync with CSS

  const clearAnimClasses = () => {
    const listEl = sliderRef.current?.innerSlider?.list;
    if (!listEl) return;
    listEl
      .querySelectorAll(
        ".banner-slide.slide-zoom-in, .banner-slide.slide-zoom-out",
      )
      .forEach((el) => el.classList.remove("slide-zoom-in", "slide-zoom-out"));
  };

  const addZoomClasses = (current, next) => {
    const listEl = sliderRef.current?.innerSlider?.list;
    if (!listEl) return;

    // always start clean
    clearAnimClasses();

    const curr = listEl.querySelector(
      `.slick-slide[data-index="${current}"] .banner-slide`,
    );
    const nxt = listEl.querySelector(
      `.slick-slide[data-index="${next}"] .banner-slide`,
    );

    if (curr) curr.classList.add("slide-zoom-out");
    if (nxt) nxt.classList.add("slide-zoom-in");
  };

  const bannerCarousel = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    pauseOnHover: true,
    // fade: true, // optionally enable if you want no lateral track motion
    beforeChange: (current, next) => addZoomClasses(current, next),
    afterChange: () => {
      // remove any leftover 'out' on non-active slides after transition
      const listEl = sliderRef.current?.innerSlider?.list;
      if (!listEl) return;
      listEl
        .querySelectorAll(".slick-slide:not(.slick-active) .banner-slide")
        .forEach((el) =>
          el.classList.remove("slide-zoom-in", "slide-zoom-out"),
        );
    },
  };

  return (
    <div>
      {isMobile ? <MenubarMob /> : <Menubar />}

      <Slider ref={sliderRef} {...bannerCarousel} className="abcd desktop">
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_1}
            alt="The Best in Campus Facilities and Resources"
          />
        </div>
        {/* <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_2}
            alt="International Opportunities"
          />
        </div> */}
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_3}
            alt="Convocation Ceremony"
          />
        </div>
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_4}
            alt="ISBM university Awarded by Honourable Dignitaries"
          />
        </div>
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_5}
            alt="ISBM university Awarded by Honourable Dignitaries"
          />
        </div>
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_6}
            alt="ISBM university Awarded by Honourable Dignitaries"
          />
        </div>
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_7}
            alt="ISBM university Awarded by Honourable Dignitaries"
          />
        </div>
        {/* <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_8}
            alt="ISBM university Campus"
          />
        </div> */}
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_9}
            alt="ISBM university Campus"
          />
        </div>
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_10}
            alt="ISBM university Campus"
          />
        </div>
        <div className="banner-slide">
          <img
            className="banner-img d-block"
            src={banner_11}
            alt="ISBM university Campus"
          />
        </div>
      </Slider>

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body"></div>
      </div>
    </div>
  );
};

export default Banner;
